import React from 'react';
import UserInput from "../UI/ReactUserInput";
import { UserTypes } from '../DataFunctions/Constants.js';
import {checkError} from 'root/DataFunctions/BaseDataFns'

export default class LoginForm extends React.Component
{
	static get defaultProps() 
	{
		return (
			{ mode: 'login'}
		)
	}
	
	constructor(props) 
	{
		super(props);

    	this.keyCount = 0 ;

		this.inpUsername = React.createRef();
		this.inpOldPassword = React.createRef();
		this.inpPassword = React.createRef();
		this.inpPassword1 = React.createRef();

        this.state = { mode: this.props.mode, user_type: this.props.user_type } ;
		
	}

	doSetFocus()
	{
		switch ( this.state.mode )
		{
			case 'login' :
				this.inpUsername.current.focus() ;
				break ;			
			case 'change_password' :
				this.inpOldPassword.current.focus() ;
				break ;			
			case 'change_password_first' :
				this.inpPassword.current.focus() ;
				break ;			
			case 'forgot_password' :
				this.inpUsername.current.focus() ;
				break ;			
		}	
	}
	
	componentDidMount()
	{
		this.doSetFocus();
	}
	
	componentDidUpdate()
	{
		this.doSetFocus();
	}
	
	redirectKnownUserType ( user_type )
	{
		let url = (this.props.options !== '' && this.props.options !== null && this.props.options !== undefined ) ?  '/vschool/?options=' + this.props.options : '/vschool/' ;

        switch(+user_type)
        {
			case UserTypes.SYSTEM_ADMIN:
			case UserTypes.TEAM_LEAD:
			case UserTypes.ESW:
			case UserTypes.SOCIAL_WORKER:
			case UserTypes.EDUCATIONAL_PSYCHOLOGIST:
			case UserTypes.ATTENDANCE_OFFICER:
			case UserTypes.DESI_TEACHER :
			case UserTypes.VIRTUAL_SCHOOL_HEAD:
			case UserTypes.PERFORMANCE_AND_DEVELOPMENT:
			case UserTypes.CAREERS_ADVISOR:
			case UserTypes.EWS_OFFICER:
			case UserTypes.LEAD_CAREERS_ADVISOR:
			case UserTypes.EHCP_COORDINATOR:

            window.location.replace(url);

            break;

          default:
            alert("Unknown user type");

          break;
        }
	}
	
	doPasswordResetConfirmation( user )
	{
		var me = this ;
		
	    var dialog = bootbox.dialog({
	        title: 'Password Reset Accepted',
	        message: "<p>You have successfully requested a password reset. Please check your email for confirmation and further instructions.</p>",
	        buttons: {
	            ok: {
	                label: "OK",
	                className: 'btn-info btn-centred',
	                callback: function()
	                {
						me.setState ({mode: 'login'}) ;	
	                }
	            }
	        }
	        });
	}
	
	doLoginFunctions( user )
	{
        const user_type = user.userTypeId;
        const userid = user.idusers;
        
		if ( user.password_change_required == 1 )
		{
			var me = this ;
			
		    var dialog = bootbox.dialog({
		        title: 'Successful Login',
		        message: "<p>You have successfully logged in but you must now change your password before continuing.</p>",
		        buttons: {
		            ok: {
		                label: "OK",
		                className: 'btn-info btn-centred',
		                callback: function()
		                {
							me.setState ({mode: 'change_password_first', user_type: user_type, user_id: userid }) ;	
		                }
		            }
		        }
		        });
		    
			}
		else
		{
            this.redirectKnownUserType ( user_type ) ;
		}
	}
	
	doChangePassword ( userid, newpass )
	{
		const url = Globals.APIFolder + '/users/' + userid+ '/changepassword' ;

		const data = { newpass: newpass } ;

        $.ajax({
            type: 'PUT',
            url: url ,
			data: data,
            success:(data)=>{
    			if ( checkError(data))
				{
    				this.redirectKnownUserType ( this.state.user_type )
				}
            },
            error:(jqXHR, textStatus, error)=>
            {
				handleAjaxError ( jqXHR, textStatus, error) ;    		  	
            }
        });
		
	}
	
	doChangeCurrentUserPassword ( oldpass, newpass )
	{
		var url = Globals.APIFolder + '/users/changepassword' ;

		let data = { oldpassword: oldpass, password: newpass } ;
		
		let me = this ;
		
        $.ajax({
            type: 'PUT',
            url: url ,
            data: { data },
            success:(data)=>{

    			if ( checkError(data))
				{
					var dialog = bootbox.dialog({
						title: 'Password change successful',
						message: "<p>Your password has now been changed</p>",
						buttons: {
							ok: {
								label: "OK",
								className: 'btn-info btn-centred',
								callback: function()
								{
				    				me.redirectKnownUserType ( me.state.user_type )
								}
							}
						}
						});
				}  				

            },
            error:(jqXHR, textStatus, error)=>
            {
				handleAjaxError ( jqXHR, textStatus, error) ;    		  	
            }
        });
		
	}
	
	
	doLogin( username, password )
	{
    	$.ajax({
    		  type: 'POST',
    		  url: Globals.APIFolder + '/login',
    		  data: { inpUsername: username, inpPassword: password },
    		  success:(data)=>
    		  {
      			if ( data.status.result == 'success')
				{
    				var user = data.data[0] ;
    				
    				this.doLoginFunctions( user );
				}
				else
				{
					if ( data.status.error == "Invalid Login" )
					{
						var me = this ;
			
						var dialog = bootbox.dialog({
							title: 'Login Failed',
							message: "<p>The credentials you entered are invalid. Please try again.</p>",
							buttons: {
								ok: {
									label: "OK",
									className: 'btn-info btn-centred',
									callback: function()
									{
										me.setState ({mode: 'login'}) ;	
									}
								}
							}
							});

					}
					else if ( data.status.error == "Login Suspended" )
					{
						var me = this ;
			
						var dialog = bootbox.dialog({
							title: 'Login Failed',
							message: "<p>The account has been suspended. Please contact your system administrator.</p>",
							buttons: {
								ok: {
									label: "OK",
									className: 'btn-info btn-centred',
									callback: function()
									{
										me.setState ({mode: 'login'}) ;	
									}
								}
							}
							});

					}
					
					else
					{
						checkError ( data ) ;
					}
				} 				
    		  },
    		  error:(jqXHR, textStatus, error)=>
    		  {
					handleAjaxError ( jqXHR, textStatus, error) ;    		  	
		  	  }

    		});
	}
	
	doPasswordReset( username )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var service = "/resetpassword" ;
		
    	$.ajax({
    		  type: 'POST',
    		  url: root + service,
    		  data: { inpUsername : username },
    		  beforeSend:function()
    		  {
    		    // this is where we append a loading image
    		  },
    		  success:(data)=>
    		  {
    			  if ( checkError(data))
				  {
    				  this.doPasswordResetConfirmation( );    				  
				  }
    		  },
    		  error:(jqXHR, textStatus, error)=>
    		  {
					handleAjaxError ( jqXHR, textStatus, error) ;    		  	
		  	  }

    		});
	}
	
	onForgotPassword()
	{
		this.setState ({mode: 'forgot_password'}) ;
	}

	onForgotPasswordCancel()
	{
		this.setState ({mode: 'login'}) ;
	}

	onLogout()
	{
		this.setState ({mode: 'login'}) ;
	}

	onCancel()
	{
      	location.assign('home.php');
	}
	
	formIsValid ()
	{
		switch ( this.state.mode )
		{
			case 'login' :
				if ( this.inpUsername.current.isValid() && this.inpPassword.current.isValid())
				{
					return true ;
				}
				else
				{
					return false ;
				}
				break ;			
			case 'change_password' :
				if ( this.inpOldPassword.current.isValid() && this.inpPassword.current.isValid() && this.inpPassword1.current.isValid())
				{
					return true ;
				}
				else
				{
					return false ;
				}
				break ;			
			case 'change_password_first' :
				if ( this.inpPassword.current.isValid() && this.inpPassword1.current.isValid())
				{
					return true ;
				}
				else
				{
					return false ;
				}
				break ;			
			case 'forgot_password' :
				if ( this.inpUsername.current.isValid())
				{
					return true ;
				}
				else
				{
					return false ;
				}
				break ;			
		}
		
		return false ;
	}
	
	getFormData()
	{
		var dataItem = {} ;
		
		switch ( this.state.mode )
		{
			case 'login' :
				dataItem.username= this.inpUsername.current.getValue() ;
				dataItem.password = this.inpPassword.current.getValue() ;
				break ;			
			case 'change_password' :
				dataItem.oldpassword= this.inpOldPassword.current.getValue() ;
				dataItem.password= this.inpPassword.current.getValue() ;
				dataItem.password1 = this.inpPassword1.current.getValue() ;
			case 'change_password_first' :
				dataItem.password= this.inpPassword.current.getValue() ;
				dataItem.password1 = this.inpPassword1.current.getValue() ;
				break ;			
			case 'forgot_password' :
				dataItem.username= this.inpUsername.current.getValue() ;
				break ;			
		}
		
		return dataItem ;
	}

	onLogin(event)
	{
		event.preventDefault() ;
		
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			var data = this.getFormData() ;
			
			this.doLogin( data.username, data.password );		
		}
	}
	
	onForgotPasswordSend(event)
	{
		event.preventDefault() ;
		
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			var data = this.getFormData() ;
			
			this.doPasswordReset( data.username );		
		}
	}
	
	onChangePassword(event)
	{
		event.preventDefault() ;
		
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			var data = this.getFormData() ;

			if ( data.password != data.password1 )
			{
				this.setState ( { displayErrors : true, formError: "Passwords must match"}) ;			
			}
			else
			{
				if ( this.state.mode == 'change_password_first')
				{
					this.doChangePassword( this.state.user_id, data.password );												
				}
				else
				{
					this.doChangeCurrentUserPassword(data.oldpassword, data.password );										
				}
			}
		}
	}
	
	
	handleChange(e) 
	{
		this.setState({ [e.target.name]: e.target.value });
	}
	 
	hyperlink ( label, link )
	{
		return <a  href={link}>{label}</a>  ;
	}
	
	panelHeading(panelDefinition)
	{
		return <div className='panel-heading'>{panelDefinition.title}</div>
	}

    logo( image_path )
    {
    	return (
    		<p key='imgKey' >
				<img src={image_path} alt='Logo' className='img img-responsive'/>
			</p>
		)
    }
    
    title( title )
    {
        return <h1 key='title'>{title}</h1> ;
    }
    
    formElement()
    {
    	let lineList = [] ;

		if ( this.props.reason === 'timeout')
		{
			lineList.push (<div key='reasonText' className='logout-reason'>You have been logged out due to inactivity</div>)
		}

    	lineList.push ( React.createElement ( UserInput, { validation: { required: true, maxlen: 100 },
			  id: 'inpUsername', 
			  name: 'inpUsername',
			  ref: this.inpUsername,
			  labelText: null, 
			  errorText: 'You must enter a valid user name',
			  placeholder: 'Username',
			  tabIndex: 1,
			  displayErrors:this.state.displayErrors,
			  key: 'intUsername'
			  }));
			  
		lineList.push ( React.createElement ( UserInput, { validation: { required: true, maxlen: 100 },
			  isPassword: true,
			  id: 'inpPassword', 
			  name: 'inpPassword',
			  ref: this.inpPassword,
			  labelText: null, 
			  errorText: 'You must enter a valid password',
			  placeholder: 'Password',
			  tabIndex: 2,
			  displayErrors:this.state.displayErrors,
			  key: 'inpPassword'
			  }));

    	lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'form-group'}, 
    		React.createElement ( 'button', { type: 'submit', className: 'btn btn-primary', id: 'submitBtn', onClick: this.onLogin.bind(this) }, 'Log in'))) ; 

    	return React.createElement ( 'form', { key: this.keyCount++, className: 'form', id: 'login_form'}, lineList ) ;
    }

    forgotPasswordformElement()
    {
    	var lineList = [] ;
    	
    	lineList.push ( React.createElement ( UserInput, { validation: { required: true, maxlen: 100 },
			  id: 'inpUsername', 
			  name: 'inpUsername',
			  ref: this.inpUsername,
			  labelText: null, 
			  errorText: 'You must enter a valid username',
			  placeholder: 'Please enter your username',
			  tabIndex: 1,
			  displayErrors:this.state.displayErrors,
			  key: this.keyCount++
			  }));

    	lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'form-group'}, 
    		React.createElement ( 'button', { type: 'submit', className: 'btn btn-primary', id: 'submitBtn', onClick: this.onForgotPasswordSend.bind(this)}, 'Reset Password'))) ; 

    	lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'form-group'}, 
        		React.createElement ( 'button', { type: 'button', className: 'btn btn-secondary', id: 'cancelBtn', onClick: this.onForgotPasswordCancel.bind(this) }, 'Cancel'))) ; 

    	return React.createElement ( 'form', { key: this.keyCount++, className: 'form', id: 'login_form'}, lineList ) ;
    }
    
    changePasswordformElement( requireOldPassword )
    {
    	var lineList = [] ;
    	
    	if ( requireOldPassword )
		{
    		lineList.push ( React.createElement ( UserInput, { validation: { required: true, maxlen: 100 },
  			  isPassword: true,
  			  autofocus: true,
  			  id: 'inpOldPassword', 
  			  name: 'inpOldPassword',
  			  ref: this.inpOldPassword,
  			  labelText: null, 
  			  errorText: 'You must enter your old password',
  			  placeholder: 'Enter OLD Password',
  			  tabIndex: 1,
  			  displayErrors:this.state.displayErrors,
  			  key: this.keyCount++
  			  }));		
		}

    	lineList.push ( React.createElement ( UserInput, { validation: { required: true, maxlen: 100 },
			  isPassword: true,
			  autofocus: true,
			  id: 'inpPassword', 
			  name: 'inpPassword',
			  ref: this.inpPassword,
			  labelText: null, 
			  errorText: 'You must enter a valid password',
			  placeholder: 'New Password',
			  tabIndex: 2,
			  displayErrors:this.state.displayErrors,
			  key: this.keyCount++
			  }));
		
		let errorMessage = "You must enter a valid password" ;
		let validation = { required: true, maxlen: 100 } ;
		
		if ( this.state.formError != null )
		{
			errorMessage = this.state.formError ;
			validation = { required: true, maxlen: 100, forceError: true }
		}

		lineList.push ( React.createElement ( UserInput, { validation: validation ,
			  isPassword: true,
			  id: 'inpPassword1', 
			  name: 'inpPassword1',
			  ref: this.inpPassword1,
			  labelText: null, 
			  errorText: errorMessage,
			  placeholder: 'Confirm Password',
			  tabIndex: 3,
			  displayErrors:this.state.displayErrors,
			  key: this.keyCount++
			  }));
		
		lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'form-group'}, 
    		React.createElement ( 'button', { type: 'submit', className: 'btn btn-primary', id: 'submitBtn', onClick: this.onChangePassword.bind(this) }, 'Change Password' ))) ; 

		if ( this.state.mode == 'change_password_first')
		{
	    	lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'form-group'}, 
	        		React.createElement ( 'button', { type: 'button', className: 'btn btn-secondary', id: 'logoutBtn', onClick: this.onLogout.bind(this) }, 'Logout'))) ; 
		}
		else
		{
	    	lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'form-group'}, 
	        		React.createElement ( 'button', { type: 'button', className: 'btn btn-secondary', id: 'logoutBtn', onClick: this.onCancel.bind(this) }, 'Cancel'))) ; 		
		}

    	return React.createElement ( 'form', { key: this.keyCount++, className: 'form', id: 'login_form'}, lineList ) ;
    }
    
    forgotPasswordLink( image_path )
    {
        return React.createElement ( 'p', { key: this.keyCount++ },
        	React.createElement ( 'a', { key: this.keyCount++, className: 'black_text', href: '#', onClick: this.onForgotPassword.bind(this) }, 'Forgot Password')) ;
    }
    	
    loginForm ()
    {
        var lineList=[];

        lineList.push ( this.logo('/images/logos/virtual_school_logo_white.png')) ;
        
        lineList.push ( this.title(this.props.title) );
        
        if ( this.state.mode == 'login')
    	{
            lineList.push ( this.formElement()) ;    	
            lineList.push ( this.forgotPasswordLink()) ;
    	}
        else if ( this.state.mode == 'forgot_password')
    	{
            lineList.push ( this.forgotPasswordformElement()) ;    	    	
    	}
        else if ( this.state.mode == 'change_password')
    	{
            lineList.push ( this.changePasswordformElement(true)) ;    	    	
    	}
        else if ( this.state.mode == 'change_password_first')
    	{
            lineList.push ( this.changePasswordformElement(false)) ;    	    	
    	}
        
        return lineList ;
    }
    
	render() 
    {
    	this.keyCount = 0 ;
    	    	
        return React.createElement ( 'div', {} , this.loginForm()) ;
    }
};



